import Xhr from '../../core/xhr'

export default {
  namespaced: true,
  state: {
    loading: false,
    seminar: null,
    seminare: [],
    countries: [],
    extendedform: new Xhr({
      locale: 'de',
      seminar: null,
      user: {
        vorname: '',
        nachname: '',
        email: '',
        gdprnews: false,
        gdprdaten: false
      }
    })
  },
  mutations: {
    user (state, user) {
      state.extendedform.user = user
    },
    seminar (state, seminar) {
      state.seminar = seminar
    },
    seminare (state, seminare) {
      state.seminare = seminare
    },
    loading (state, loading) {
      state.loading = loading
    },
    update (state, [key, value]) {
      state[key] = value
    }
  },
  actions: {
    update ({ commit }, [key, value]) {
      commit(key, value)
    },
    async fetchSeminar ({ commit, rootState }, { id }) {
      try {
        const locale = rootState.locale
        var seminar = await new Xhr({ id, locale }).post(`${rootState.url}/extended-form/event`)
        var countries = await new Xhr().get(`${rootState.url}/extended-form/countries`)
        commit('seminar', seminar)
        commit('update', ['countries', countries])
      } catch (error) {
        console.log(error)
      }
      return { seminar } || { success: false }
    },
    async fetchData ({ commit, rootState }) {
      try {
        var seminare = await new Xhr().get(`${rootState.url}/extended-form/events`)
        commit('seminare', seminare)
      } catch (error) {
        console.log(error)
      }
      return { seminare } || { success: false }
    },
    async store ({ commit, state, rootState }) {
      commit('loading', true)
      try {
        state.extendedform.seminar = state.seminar
        state.extendedform.locale = rootState.locale
        var response = await state.extendedform.post(`${rootState.url}/extended-form/store`)
      } catch (error) {
        console.log(error)
      }
      commit('loading', false)
      return response || { success: false }
    }
  }
}
